import React, { useEffect, useMemo, useState } from 'react';
import { isMobile, isIpad } from '../../utils/ScreenSizeHelper';
import Dialog from '@mui/material/Dialog';
import BookingCalendar from './BookingCalendar';
import MerchantContactForm from './MerchantContactForm';
import ContactUsDialog from './ContactUsDialog';

export default function StorePackageWalkAppointment() {
  const phrases = useMemo(
    () => [
      'We grow together, no hidden costs.',
      'Extra stream of passive income',
      'Real support from a local team',
    ],
    []
  );

  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const intervalMs = 3200;
    const fadeMs = 260;

    const t = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((i) => (i + 1) % phrases.length);
        setVisible(true);
      }, fadeMs);
    }, intervalMs);

    return () => clearInterval(t);
  }, [phrases.length]);

  // 🔹 Dynamic sizing by device
  const titleSize = isMobile ? 16 : isIpad ? 22 : 28;
  const subtitleSize = isMobile ? 14 : isIpad ? 15 : 18;
  const flipSize = isMobile ? 12 : isIpad ? 14 : 16;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        // background: '#FAF3E1',
        boxSizing: 'border-box',
        background: 'linear-gradient(135deg, rgb(250, 243, 225), rgb(255, 250, 240))',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '950px',
          padding: '20px',
        }}
      >
        <h1
          style={{
            ...styles.title,
            fontSize: titleSize,
            textAlign: isMobile ? 'center' : 'center',
            marginTop: isMobile ? '2%' : '5%',
            color: 'rgb(24, 20, 54)',
          }}
        >
          A short, no-pressure in-person conversation to see if we’re a good fit, with each account
          tailored to your restaurant’s needs.
        </h1>

        <p
          style={{
            ...styles.subtitle,
            fontSize: subtitleSize,
            color: 'gray',
          }}
        >
          As a{' '}
          <span
            style={{
              position: 'relative',
              display: 'inline-block',
              fontFamily: 'Inter Bold',
            }}
          >
            Chicago based startup
            <span
              style={{
                position: 'absolute',
                left: '-4px',
                bottom: '-3px',
                width: '110%',
                height: '6px',
                borderBottom: '4px solid rgb(252, 93, 27)',
                borderRadius: '20%',
                transform: 'rotate(-1deg)',
                content: "''",
              }}
            />
          </span>
          , we work hands-on with restaurants to attract nearby customers. We create and promote
          short videos, reels, and content on social platforms—no upfront marketing spend required.
        </p>

        <div style={styles.flipRow} aria-live='polite'>
          <span
            style={{
              ...styles.flipText,
              fontSize: flipSize,
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0px)' : 'translateY(6px)',
            }}
          >
            {phrases[index]}
          </span>
        </div>

        <div
          style={{
            border: '2px solid black',
            // width: '500px',
            // height: '300px',
            marginTop: '20px',
            borderRadius: '5px',
            backgroundColor: 'white',
            padding: '20px',
          }}
        >
          <div
            style={{
              fontFamily: 'Inter Medium',
              fontSize: isMobile ? '14px' : '16px',
              textAlign: 'center',
            }}
          >
            <p style={{ fontWeight: 700, fontSize: 17, margin: 0 }}>We'd love to work with you.</p>
            <p style={{ fontSize: 14.5, color: '#6B625A', margin: '6px 0 0' }}>
              Share your details and we'll reach out — we always call before we visit.
            </p>
            <ContactUsDialog isMobile={isMobile} text='Contact Us' />
            {/* <BookingCalendar
              buttonWrapStyle={{
                position: 'fixed',
                bottom: 80,
                right: 16,
                zIndex: 9999,
                marginTop: '10px',
              }}
            /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  section: {
    width: '100%',
    boxSizing: 'border-box',
    background: 'linear-gradient(135deg, rgb(250, 243, 225), rgb(255, 250, 240))',
    borderRadius: 16,
  },

  container: {
    width: '100%',
    maxWidth: 980,
    // width: '100%',
    boxSizing: 'border-box',
    background: 'linear-gradient(135deg, rgb(250, 243, 225), rgb(255, 250, 240))',
    margin: '0 auto',
  },

  card: {
    width: '100%',
    borderRadius: 16,
    padding: '16px',
    background: 'rgba(255,255,255,0.6)',
    border: '1px solid rgba(0,0,0,0.06)',
    boxShadow: '0 10px 22px rgba(0,0,0,0.06)',
  },

  title: {
    margin: 0,
    fontFamily:
      'Inter Medium, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    lineHeight: 1.15,
    letterSpacing: '0.5px',
    color: 'rgb(24, 20, 54)',
    fontWeight: 800,
  },

  subtitle: {
    margin: '12px auto 0',
    maxWidth: 720,
    letterSpacing: '0.5px',
    fontFamily:
      'Inter Regular, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    lineHeight: 1.6,
    color: 'rgba(24, 20, 54, 0.86)',
    fontWeight: 500,
    textAlign: 'center',
  },

  flipRow: {
    marginTop: 14,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 34,
  },

  flipText: {
    display: 'inline-block',
    padding: '9px 14px',
    borderRadius: 999,
    background: 'rgba(24, 20, 54, 0.08)',
    border: '1px solid rgba(24, 20, 54, 0.14)',
    color: 'rgb(24, 20, 54)',
    // fontWeight: 700,
    transition: 'opacity 240ms ease, transform 240ms ease',
    textAlign: 'center',
  },
};
